import Message from './Message';
import { useGetPaypalStandardConfigQuery } from '../slices/paypalStandardApiSlice';
import { useGetPaypalSandboxConfigQuery, useGetPaypalSandboxSellerQuery } from '../slices/paypalSandboxApiSlice';

export default function CreatorPaymentWarning({ user }) {
  const stripeReady = user?.businessMethods?.some(method => method.type === 'stripe'
    && method.stripe?.accountId && method.stripe.chargesEnabled && method.stripe.payoutsEnabled);
  const standard = useGetPaypalStandardConfigQuery(undefined, { skip: Boolean(user?.isPlatformAccount || stripeReady), refetchOnMountOrArgChange: true });
  const standardReady = standard.data?.enabled && standard.data?.teamUserId === user?._id;
  const alreadyEligible = Boolean(user?.isPlatformAccount || stripeReady || standardReady);
  const config = useGetPaypalSandboxConfigQuery(undefined, {
    skip: alreadyEligible, refetchOnMountOrArgChange: true,
  });
  // Scope cached status to the signed-in creator; the server determines identity from the session.
  const status = useGetPaypalSandboxSellerQuery(user?._id, {
    skip: alreadyEligible || !config.data?.enabled || !user?._id,
    refetchOnMountOrArgChange: true,
  });
  if (alreadyEligible) return null;
  if (standard.isFetching || config.isFetching || (config.data?.enabled && status.isFetching)) {
    return <Message>Checking payment onboarding status...</Message>;
  }
  if (standard.error || config.error || (config.data?.enabled && status.error)) {
    return <Message variant="warning">Could not check payment onboarding. Refresh the page or check My Payment Methods.</Message>;
  }
  if (config.data?.enabled && status.currentData?.ready === true) return null;
  return <Message variant="warning">
    Your creator payment onboarding is incomplete. Products can be created, but they will remain hidden
    from marketplace listings until Stripe onboarding is complete with charges and payouts enabled
    {config.data?.enabled ? ', or PayPal sandbox onboarding is complete and ready to receive payments.' : '.'}
  </Message>;
}
